import { auth } from "..";

export const updateGhostMode = async (data) => {
    const res = await auth({
        method: "POST",
        url: "/users/location/visibility",
        data
    });
    return res
};